import { render } from "./MeetingsWrapper.vue?vue&type=template&id=63a9f92d&scoped=true"
import script from "./MeetingsWrapper.vue?vue&type=script&lang=js"
export * from "./MeetingsWrapper.vue?vue&type=script&lang=js"

import "./MeetingsWrapper.vue?vue&type=style&index=0&id=63a9f92d&lang=scss&scoped=true"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a9f92d"]])

export default __exports__